import React from 'react';
import SafeIcon from '../common/SafeIcon';

export const Footer = () => {
  return (
    <footer className="bg-[#0a192f] pt-20 pb-10 border-t-4 border-[#93e9be]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="col-span-1 lg:col-span-1">
            <div className="flex items-center mb-6">
              <SafeIcon name="Wind" className="h-8 w-8 text-[#93e9be] mr-2" />
              <span className="font-bold text-2xl tracking-tighter text-white">
                TIDECRAFT<span className="text-[#ff7f50]">.</span>
              </span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Premium coastal surf gear engineered for the dedicated waterman. Ride the energy.
            </p>
            <div className="flex space-x-4">
              {['Instagram', 'Twitter', 'Facebook'].map((social) => (
                <a key={social} href="#" className="w-10 h-10 rounded-full bg-[#0f294d] flex items-center justify-center text-[#93e9be] hover:bg-[#ff7f50] hover:text-white transition-colors">
                  <SafeIcon name={social} className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6">Shop</h4>
            <ul className="space-y-3">
              {['Surfboards', 'Wetsuits', 'Accessories', 'Apparel', 'Starter Bundles'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 hover:text-[#93e9be] transition-colors">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6">Support</h4>
            <ul className="space-y-3">
              {['Contact Us', 'Shipping & Returns', 'Board Registration', 'Volume Calculator', 'FAQ'].map((item) => (
                <li key={item}>
                  <a href={`#${item.toLowerCase() === 'faq' ? 'faq' : ''}`} className="text-gray-400 hover:text-[#93e9be] transition-colors">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6">Join the Lineup</h4>
            <p className="text-gray-400 mb-4">Subscribe for early access to new shapes and exclusive content.</p>
            <form className="flex flex-col space-y-3">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="bg-[#0f294d] border border-gray-700 text-white px-4 py-3 rounded-lg focus:outline-none focus:border-[#93e9be] transition-colors"
                required
              />
              <button 
                type="submit" 
                className="bg-[#93e9be] text-[#0a192f] font-bold px-4 py-3 rounded-lg hover:bg-white transition-colors flex justify-center items-center"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Tidecraft Surf Co. All rights reserved.
          </p>
          <div className="text-gray-500 text-sm flex items-center bg-[#0f294d] px-4 py-2 rounded-full border border-gray-800">
            Made by <span className="text-[#93e9be] font-bold mx-1">LingLink AI</span> and <span className="text-[#ff7f50] font-bold ml-1">DigLab AI</span>
          </div>
        </div>

      </div>
    </footer>
  );
};